import instaFeedIcon from "../../images/instagram-icon.svg";
import instaReelsIcon from "../../images/instagram-reels-icon.svg";
import tiktokIcon from "../../images/tiktok-icon.svg";
import youtubeIcon from "../../images/youtube-icon.svg";
import youtubeShortsIcon from "../../images/youtube-shorts-icon.svg";

const IMG_BOX_DEFAULT = "h-[1.2em] w-[1.2em] object-contain";
const IMG_BOX_INSTAGRAM_FEED = "h-[0.9em] w-[0.9em] object-contain";
const IMG_BOX_INSTAGRAM_REELS = "h-[0.82em] w-[0.82em] object-contain";

function ContentFormatImageIcon({
  src,
  className,
  style,
  imgClassName,
  ...rest
}) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center leading-none ${
        className ?? ""
      }`}
      style={style}
      {...rest}
    >
      <img
        src={src}
        alt=""
        className={imgClassName ?? IMG_BOX_DEFAULT}
        draggable={false}
      />
    </span>
  );
}

export function InstagramReelsFormatIcon(props) {
  return (
    <ContentFormatImageIcon
      src={instaReelsIcon}
      imgClassName={IMG_BOX_INSTAGRAM_REELS}
      {...props}
    />
  );
}

export function InstagramFeedFormatIcon(props) {
  return (
    <ContentFormatImageIcon
      src={instaFeedIcon}
      imgClassName={IMG_BOX_INSTAGRAM_FEED}
      {...props}
    />
  );
}

function TikTokFormatIcon(props) {
  return <ContentFormatImageIcon src={tiktokIcon} {...props} />;
}

function YoutubeShortsFormatIcon(props) {
  return <ContentFormatImageIcon src={youtubeShortsIcon} {...props} />;
}

function YoutubeLongformFormatIcon(props) {
  return <ContentFormatImageIcon src={youtubeIcon} {...props} />;
}

export const CONTENT_FORMAT_OPTIONS = [
  {
    value: "tiktok_video",
    label: "영상",
    shortLabel: "틱톡 영상",
    Icon: TikTokFormatIcon,
  },
  {
    value: "tiktok_feed",
    label: "피드",
    shortLabel: "틱톡 피드",
    Icon: TikTokFormatIcon,
  },
  {
    value: "instagram_reels",
    label: "릴스",
    shortLabel: "인스타그램 릴스",
    Icon: InstagramReelsFormatIcon,
  },
  {
    value: "instagram_feed",
    label: "피드",
    shortLabel: "인스타그램 피드",
    Icon: InstagramFeedFormatIcon,
  },

  {
    value: "youtube_longform",
    label: "롱폼",
    shortLabel: "유튜브 롱폼",
    Icon: YoutubeLongformFormatIcon,
  },
  {
    value: "youtube_shorts",
    label: "쇼츠",
    shortLabel: "유튜브 쇼츠",
    Icon: YoutubeShortsFormatIcon,
  },
];

export const parseContentFormatValues = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }

  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export const getContentFormatOptions = (value) => {
  const values = parseContentFormatValues(value);
  const selectedValues = new Set(values);

  return CONTENT_FORMAT_OPTIONS.filter((option) =>
    selectedValues.has(option.value)
  );
};

export const getContentFormatLabel = (value) => {
  const values = parseContentFormatValues(value);
  if (values.length === 0) return "-";

  const options = getContentFormatOptions(value);
  if (options.length === 0) return values.join(", ");

  return options.map((option) => option.label).join(", ");
};
